import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import { TextField, SelectField, Checkbox } from 'redux-form-material-ui';
import { reduxForm, Field } from 'redux-form';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import { required, email } from '../utils/form-validators';
import i18n from '../translations/i18n';

/*
  Styled components
 */
const ButtonContainer = styled.div`
  margin-top: 30;
  float: right;
`;

const StyledSubmitButton = styled(RaisedButton)`
  margin-left: 5px !important;
`;

const CheckGroupLabel = styled.div`
  line-height: 22px;
  z-index: 1;
  pointer-events: none;
  user-select: none;
  color: rgba(0, 0, 0, 0.3);
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  isModify: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const defaultProps = {
  isModify: false,
};

function EndUserForm(props) {
  const { handleSubmit, isModify } = props;

  const passValidation = isModify ? [required] : null;
  const usernameDisabled = !!isModify;

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-6">
          <div className="box">
            <Field
              component={TextField}
              validate={[required]}
              name="first_name"
              hintText={props.t('first_name')}
              floatingLabelText={props.t('first_name')}
              fullWidth
            />

            <Field
              component={TextField}
              validate={[required]}
              name="last_name"
              hintText={props.t('first_name')}
              floatingLabelText={props.t('last_name')}
              fullWidth
            />

            <Field
              component={TextField}
              name="mobile_phone"
              hintText={props.t('mobile_phone')}
              floatingLabelText={props.t('mobile_phone')}
              fullWidth
            />

            <Field
              component={TextField}
              validate={[required, email]}
              name="email"
              hintText={props.t('email')}
              floatingLabelText={props.t('email')}
              fullWidth
            />

            <Field
              component={TextField}
              name="street"
              hintText={props.t('street')}
              floatingLabelText={props.t('street')}
              fullWidth
            />

            <Field
              component={TextField}
              name="street_number"
              hintText={props.t('street_nr')}
              floatingLabelText={props.t('street_nr')}
              fullWidth
            />

            <Field
              component={TextField}
              name="place"
              hintText={props.t('place')}
              floatingLabelText={props.t('place')}
              fullWidth
            />
          </div>
        </div>
        <div className="col-xs-6">
          <div className="box">
            <Field
              name="lang"
              component={SelectField}
              floatingLabelText={props.t('language')}
              hintText={props.t('select_language')}
            >
              <MenuItem value="EN" primaryText="EN" />
              <MenuItem value="DE" primaryText="DE" />
              <MenuItem value="FR" primaryText="FR" />
              <MenuItem value="IT" primaryText="IT" />
            </Field>

            <CheckGroupLabel>{props.t('notification_options')}</CheckGroupLabel>
            <div className="row">
              <Field
                className="col-xs-6"
                name="notification_email"
                component={Checkbox}
                label={props.t('email')}
              />
              <Field
                className="col-xs-6"
                name="notification_push"
                component={Checkbox}
                label={props.t('push')}
              />
            </div>

            <Field
              component={TextField}
              validate={[required]}
              disabled={usernameDisabled}
              name="username"
              hintText={props.t('username')}
              floatingLabelText={props.t('username')}
              fullWidth
            />

            <Field
              component={TextField}
              validate={passValidation}
              name="password"
              type="password"
              hintText={props.t('password')}
              floatingLabelText={props.t('password')}
              fullWidth
            />

            <Field
              component={TextField}
              validate={passValidation}
              name="password_repeated"
              type="password"
              hintText={props.t('repeat_password')}
              floatingLabelText={props.t('repeat_password')}
              fullWidth
            />
          </div>
        </div>
      </div>
      <ButtonContainer>
        <Link onClick={browserHistory.goBack}>
          <RaisedButton label={props.t('back')} />
        </Link>

        <StyledSubmitButton label={props.t('save')} type="submit" primary />
      </ButtonContainer>
    </form>
  );
}
EndUserForm.propTypes = propTypes;
EndUserForm.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(EndUserForm);
export default reduxForm({ form: 'endUser' })(localize(extended, 'locale'));



// WEBPACK FOOTER //
// ./src/components/EndUserForm.js